import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Drink } from "src/lib/db";
import useGetDrinkIconUrl from "src/lib/hooks/useGetIcon";
import { removeDrink } from "src/lib/slices/ownItems";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader } from "../ui/card";
import AddOwnDrinkDrawer from "./AddOwnDrink";

export default function OwnDrinkCard({ drink }: { drink: Drink }) {
  const dispatch = useDispatch();

  const drinkIconUrl = useGetDrinkIconUrl(drink);

  const [clickedDelete, setClickedDelete] = useState(false);

  useEffect(() => {
    if (clickedDelete) {
      const timeout = setTimeout(() => {
        setClickedDelete(false);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [clickedDelete]);

  const deleteDrinkRecord = () => {
    if (clickedDelete) {
      dispatch(removeDrink(drink.id));
    }
    setClickedDelete(true);
  };

  return (
    <Card
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
      }}
      key={drink.id}
    >
      <CardHeader
        style={{
          padding: "0.25rem",
          textAlign: "center",
          paddingBottom: 0,
          fontWeight: "500",
        }}
      >
        {drink.name}
      </CardHeader>
      <CardContent
        style={{
          padding: "0.25rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <img
            src={drinkIconUrl}
            style={{
              height: "5rem",
              maxWidth: "100%",
              objectFit: "contain",
            }}
            alt=""
          />
        </div>
        <div
          style={{
            textAlign: "center",
            fontWeight: "500",
            fontSize: "0.75rem",
          }}
        >
          {drink.alcoholVolume} %
        </div>
      </CardContent>
      <Button
        style={{ position: "absolute", top: "-0.75rem", right: "-0.75rem" }}
        size="icon"
        variant={clickedDelete ? "destructive" : "outline"}
        onClick={deleteDrinkRecord}
      >
        <TrashIcon />
      </Button>
      <AddOwnDrinkDrawer drink={drink}>
        <Button
          style={{ position: "absolute", top: "-0.75rem", left: "-0.75rem" }}
          size="icon"
          variant="outline"
        >
          <Pencil1Icon />
        </Button>
      </AddOwnDrinkDrawer>
    </Card>
  );
}
